import { Box, Card, CircularProgress, Typography } from "@mui/material";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { BudgetDashboardMonthlyItem } from "../../../types/dashboard";
import { formatPercent } from "../utils";

interface AdoptionEvolutionChartProps {
  data: BudgetDashboardMonthlyItem[];
  isLoading: boolean;
}

export const AdoptionEvolutionChart = ({
  data,
  isLoading,
}: AdoptionEvolutionChartProps) => (
  <Card
    elevation={0}
    sx={{
      p: "18px 20px",
      mb: "18px",
      borderRadius: "12px",
      border: "1px solid #E4E7EC",
    }}
  >
    <Box mb="14px">
      <Typography fontSize={15} fontWeight={700}>
        Evolução da adoção
      </Typography>
      <Typography color="#6B7686" fontSize={12.5}>
        Projetos criados por mês (barras) e percentual com orçamento vinculado
        (linha).
      </Typography>
    </Box>

    <Box height={280}>
      {isLoading ? (
        <Box
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="label" />
            <YAxis yAxisId="left" allowDecimals={false} />
            <YAxis
              yAxisId="right"
              orientation="right"
              domain={[0, 100]}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip
              formatter={(value: any, name: string) =>
                name === "% Adoção"
                  ? [formatPercent(Number(value)), name]
                  : [value, name]
              }
            />
            <Legend />
            <Bar
              yAxisId="left"
              dataKey="projects"
              name="Projetos criados"
              fill="#1361A4"
              radius={[6, 6, 0, 0]}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="adoptionRate"
              name="% Adoção"
              stroke="#7C3AED"
              strokeWidth={2}
              dot={{ r: 3, fill: "#7C3AED" }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </Box>
  </Card>
);
